import { LogoColors, LOGO_COLOR_VALUES } from './constants';

export const LogoViewBox = '0 0 48 48';

export type IterableLogoSvgProps = {
  /** The height of the logo */
  height?: number;
  /** The Array of Colors and Opacities for the Logo Fill
   * format - [ [ color, opacity ]x4 ]
   * Defaults to colored logo */
  color: (typeof LOGO_COLOR_VALUES)[0];
};

export const IterableLogoSvg = ({
  color = LOGO_COLOR_VALUES[LogoColors.COLOR],
  height,
  ...props
}: IterableLogoSvgProps) => (
  <svg
    data-test="logo-svg" // default data-test, overridden by props if one is passed in
    xmlns="http://www.w3.org/2000/svg"
    viewBox={LogoViewBox}
    height={height}
    width={height ? undefined : '100%'}
    {...props}
  >
    <g fill="none" fillRule="nonzero">
      <path
        fill={color[0][0]}
        d="M2.46327722 19.063383L19.90195533 1.62470487l8.784898 8.784898L11.24817522 27.848281z"
        opacity={color[0][1]}
      />
      <path
        fill={color[1][0]}
        d="M19.75854796 10.82599175l8.784898-8.784898 17.43867812 17.43867812-8.784898 8.784898z"
        opacity={color[1][1]}
      />
      <path
        fill={color[2][0]}
        d="M19.86557152 37.05314013L37.30424963 19.614462l8.784898 8.784898-17.43867811 17.43867812z"
        opacity={color[2][1]}
      />
      <path
        fill={color[3][0]}
        d="M2.04960266 28.41855201l8.784898-8.784898 17.43867812 17.43867812-8.784898 8.784898z"
        opacity={color[3][1]}
      />
      <g>
        <circle cx="24.0364238" cy="6.30463576" r="6.25827815" fill={color[0][0]} />
        <circle cx="41.6986755" cy="24.0364238" r="6.25827815" fill={color[1][0]} />
        <circle cx="24.0364238" cy="41.6986755" r="6.25827815" fill={color[2][0]} />
        <circle cx="6.37417219" cy="23.9668874" r="6.25827815" fill={color[3][0]} />
      </g>
    </g>
  </svg>
);
